import { createContext, useContext, useState, useCallback } from "react";
import { T } from "./translations";

const LanguageContext = createContext({ lang: "en", t: T.en, setLang: () => {} });
export const useLang = () => useContext(LanguageContext);

const getInitial = () => {
  if (typeof window === "undefined") return "en";
  const seg = window.location.pathname.split("/")[1];
  if (seg === "de" || seg === "el") return seg;
  if (seg === "") return "en";
  const saved = localStorage.getItem("tribe_lang");
  if (saved && T[saved]) return saved;
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((code) => {
    if (!T[code]) return;
    setLangState(code);
    try {
      localStorage.setItem("tribe_lang", code);
      document.documentElement.lang = code;
    } catch {
      /* noop */
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: T[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};
